import React from "react";

const Fallback = ({ style }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="166.316"
      height="228.678"
      viewBox="0 0 166.316 228.678"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rettangolo_410"
            width="166.316"
            height="228.678"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Raggruppa_716" opacity="0.406">
        <g id="Raggruppa_715">
          <path
            id="Tracciato_214"
            d="M50.237,169.746V78.061h50.939l-.018,61.108v0a3.037,3.037,0,0,1-3.031,3.027H90.01v12.8h39.15v-12.8h-8.141a3.037,3.037,0,0,1-3.026-3.021v-4.666h0l0-118.743a3.033,3.033,0,0,1,2.954-3.018l8.208.011V0H90.01V12.757h8.142a3.035,3.035,0,0,1,3.025,3.016v6.972h0V60.378H50.237V15.784a3.036,3.036,0,0,1,3.03-3.027h8.22V0H22.339V12.757h8.072a3.035,3.035,0,0,1,3.007,3V169.746H12.283a11.243,11.243,0,0,0-1.3-.021,10.979,10.979,0,0,0-8.518,17.911l-.027.021L34.3,228.527c.16.16.671.15.671.15H50.237V186.565H166.316V169.746Zm-16.819,30.3L22.912,186.565H33.419Z"
            fill="#a2a2a2"
          />
        </g>
      </g>
    </svg>
  );
};

export default Fallback;
